import { Divider } from 'antd';
import { DividerProps } from 'antd/lib';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';

const StyledDivider = styled(Divider)`
  &.ant-divider {
    &.color-primary {
      border-block-start-color: ${props => props.theme.colorPrimaryBorder};
      color: ${props => props.theme.colorPrimary};
    }
    &.remove-top-margin {
      margin-top: 0;
    }
  }
`;

const H2Title = styled.h2`
  margin-bottom: 0;
  &.sr-only {
    width: 100%;
    height: 100%;
    top: 0;
  }
`;
const A11YDividerWrapper = styled.div`
  position: relative;
  > hr {
    position: absolute;
    width: 100%;
    top: 0;
  }
`;

export interface DividerTitleElementProps {
  title?: React.ReactNode;
  /** Rimuove il margine superiore */
  removeTopMargin?: boolean;
  required?: boolean;

  orientation?: DividerProps['orientation'];
  color?: 'primary' | 'secondary';
}

/**
 * Elemento divisore con titolo
 */
export function DividerTitleElement(props: DividerTitleElementProps) {
  const { orientation = 'left', color = 'primary' } = props;
  if (!props.title) {
    return null;
  }

  return (
    <A11YDividerWrapper>
      <StyledDivider
        aria-hidden="true"
        className={clx({
          'remove-top-margin': props.removeTopMargin,
          'color-primary': color === 'primary',
        })}
        orientation={orientation}
        orientationMargin="0"
      >
        {props.title}{' '}
        {props.required && <span style={{ color: 'red' }}>*</span>}
      </StyledDivider>
      <hr className="sr-only" />
      <H2Title className="sr-only">{props.title}</H2Title>
    </A11YDividerWrapper>
  );
}
